<template>
  <v-list-group ref="agListGroup" v-model="expanded" class="ag-list-group" :is-disabled="disabled">
    <template #activator="{ props }">
      <v-list-item v-bind="props" :title="title">
        <template v-if="showCheckbox" #prepend>
          <v-checkbox hide-details :disabled="disabled" :model-value="active" @click.stop="onClick" />
        </template>

        <template #append>
          <AGButtonIcon icon="mdi-chevron-down" size="md" @click="expanded = !expanded" />
        </template>
      </v-list-item>
    </template>

    <slot name="items" />
  </v-list-group>
</template>

<script>
import AGButtonIcon from '@/components/common/AGButtonIcon.vue';

export default {
  components: { AGButtonIcon },

  emits: ['update:modelValue', 'click'],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: '',
    },

    active: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    showCheckbox: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    expanded: {
      get() {
        return this.modelValue;
      },

      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },

  methods: {
    onClick() {
      if (!this.showCheckbox) return (this.expanded = !this.expanded);

      if (this.disabled) return;

      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
.v-list {
  padding: 0;
}

.ag-list-group {
  .v-list-item-title {
    font-size: $font-size-xs;
    font-weight: $font-weight-regular;
    line-height: 18.62px;
    letter-spacing: 0.01em;
    text-align: left;
    color: $neutral-color-high-dark;
  }

  ::v-deep(.v-list-group__header) {
    min-height: 64px;
    max-height: 64px;
    padding: $spacing-inset-04 $spacing-inset-05;
    background-color: $neutral-color-low-light;

    &:before {
      opacity: 0 !important;
    }

    &:hover {
      background-color: $brand-color-highlight-light !important;
    }
  }

  ::v-deep(.v-list-group__header__append-icon) {
    display: none;
  }

  ::v-deep(.v-list-item__action) {
    margin: 0;
  }

  ::v-deep(.v-list-item--active) {
    .v-list-group__header {
      background-color: $brand-color-primary-light;
    }

    .ag-btn-icon {
      transform: rotate(180deg);
    }
  }

  ::v-deep(.v-list-group__items) .ag-list-item {
    padding-left: 32px !important;
    background-color: $neutral-color-low-medium;
  }

  &[is-disabled='true'] ::v-deep(.v-list-group__header) {
    background-color: $neutral-color-low-dark;
  }

  &[has-subtitle='true'] {
    min-height: 70px;
    max-height: 70px;

    .v-list-item-title {
      font-weight: $font-weight-bold;
    }
  }

  &:active,
  &::v-deep(.v-list-item--active) {
    background-color: $brand-color-primary-light !important;
  }

  &[is-disabled='true'] {
    .v-list-item-title {
      color: $neutral-color-high-medium;
    }
  }
}
</style>
